import React from 'react';

import classNames from 'classnames';

import { useGetTeam } from '@entities/myTeam/lib/hooks';
import { changeTariff } from '@entities/tariff/lib';
import { Icon, UiText } from '@shared/ui';

import cls from './AddEmployer.module.css';
import { useAddEmployee } from '../../lib/hooks/useAddEmployee';
import { useMyTeamContext } from '../../model/context';

interface AddEmployerProps {
    classes?: string;
}

export const AddEmployee = ({ classes }: AddEmployerProps) => {
    const { t } = useAddEmployee();
    const { onChangeCurrentModal } = useMyTeamContext();

    const { data } = useGetTeam();

    const { isCanAddEmployee, isOwner } = data || {};

    return (
        <button
            className={classNames(cls.AddEmployee, [classes])}
            onClick={async (e) => {
                e.stopPropagation();
                if (isCanAddEmployee) {
                    onChangeCurrentModal('addEmployee');
                    return;
                }
                await changeTariff(isOwner);
            }}
        >
            <Icon iconName="addEmployee" />
            <UiText tag="span" variant="mediumPlain" align="center">
                {t('AddEmployer.return.AddEmployer')}
            </UiText>
        </button>
    );
};
